<div class="col-12 styledNoteContainer" [ngStyle]="{'margin-left': formViewFlag && isChildItem  ? '-15px' :''}">
  <div class="wrapper" #signaturepadWrapper
    [ngClass]="{
  'disabled': showAdditionalActions || submit || isDisableResponse,
  'height-class': type === doodleType,
  'imageBackcolor': type === doodleType && !formViewFlag,
  'childheight-class': formViewFlag === true && isChildItem==true && type === signatureType
}"
>
    <!---formViewFlag === true ? 'height-class':'' --->
    <canvas [id]="this.category + '-' + this.index + '-' + this.group + '-' + this.groupItem + '-' + this.child"
      #signaturePadDuplicate [width]='width' [height]='height' class="signature-pad disableformViewColor"
      ><!--[ngClass]="[formViewFlag=== true && type != doodleType ? 'formViewColor':'disableformViewColor']"-->
    </canvas>
  </div>
  <div class="ml-5 mb-5 style-center d-flex buttonContainer" *ngIf="!showAdditionalActions && showIcons && !isDisableResponse">

    <a href="javascript:void(0)" class="checkItem" (click)="
      SaveSignature()
      ">
      <i class="fa fa-check-circle"></i>
    </a>
    <a href="javascript:void(0)" class="deleteItem" (click)="
      clearSignature()
      ">
      <i class="fa fa-times-circle"></i>
    </a>
  </div>
  <div class="ml-5 mb-5 style-center d-flex buttonContainer" *ngIf="showAdditionalActions">
  <div class="d-flex justify-content-end styledMargin actionClass" *ngIf="showAdditionalActions">
    <div>
      <div class="mb-2">
        <a href="javascript:void(0)" [ngClass]="[isDisableResponse ? 'AddItem assesmentAddBtn sigbtndisabled':'AddItem assesmentAddBtn']"  (click)="isDisableResponse ? ($event?.preventDefault()) :
          editSignature(
            category,index
          )
        ">
          <i aria-hidden="true" class="fa fa-plus mr-1"></i>{{(type === signatureType ? 'Edit Signature' : 'Edit Doodle') | translate}}
        </a>
      </div>
      <div class="mb-2">
        <a href="javascript:void(0)" [ngClass]="[isDisableResponse ? 'AddItem assesmentAddBtn sigbtndisabled':'AddItem assesmentAddBtn']"  (click)="isDisableResponse ? ($event?.preventDefault()) :
        clearSignature()
        ">
          <i aria-hidden="true" class="fa fa-minus mr-1"></i>{{(type === signatureType ? 'Delete Signature' : 'Delete Doodle') | translate}}
        </a>
      </div>
    </div>
  </div>
</div>
</div>
